import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './laser-board.css';
import styles from './laser-board.css';
import { findDOMNode } from 'react-dom';

class LaserBoard extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      X: -10,
      Y: -10,
      path: 'M10 10  20 20',
      gX1: 0,
      gY1: 0,
      gX2: 0,
      gY2: 0,
      visible: true,
      show: true,
    };
    this.boardSize = null;
    this.penQ = [];
    this.handleMouseMove;
    this.loaded = false;
  }

  componentDidMount() {
	  window.addEventListener('resize', this.resize);
    this.resize();
    let self = this;
    let trail = [];
    let mouse = { X: 0, Y: 0 }, length = 12;
    let moved = false;
    // 监听鼠标移动
    this.handleMouseMove = showMousePosition;
    document.addEventListener('mousemove', showMousePosition, false);
    this.props.liveDelegate.event.on('playerMouseMove', (event) => {
      showMousePosition(event);
    });
    function showMousePosition(event) {
      mouse.X = event.clientX;
      mouse.Y = event.clientY;
      moved = true;
    };
    // 初始化参数
    for (let i = 0; i < 12; i++) {
      trail.push({
        X: mouse.X,
        Y: mouse.Y
      })
    }

    function draw(point) {
      let x = point.X,
        y = point.Y;
      //   console.log('laser point:' + x + ',' + y);
      for (let i = 0; i < length; i++) {
        let nextDot = trail[i + 1] || trail[0];
        trail[i].X = x;
        trail[i].Y = y;

        x += (nextDot.X - x) * .3;
        y += (nextDot.Y - y) * .3;
      }

      let dx = point.X - trail[1].X,
        dy = point.Y - trail[1].Y
        ;

      let
        x1 = 0,
        y1 = 0,
        x2 = 0,
        y2 = 0
        ;

      if (Math.abs(dx) > Math.abs(dy)) {
        if (dx > 0) {
          x2 = 1;
        } else {
          x1 = 1;
        }
      } else {
        if (dy > 0) {
          y2 = 1;
        } else {
          y1 = 1;
        }
      }


      let M = `M ${trail[length - 1].X}, ${trail[length - 1].Y} `;
      let C = `C ${trail[length / 2].X}, ${trail[length / 2].Y} ${trail[length / 2].X}, ${trail[length / 2].Y} ${trail[length / 2 - 1].X}, ${trail[length / 2 - 1].Y} `;
      let S = `S ${trail[2].X}, ${trail[2].Y} ${trail[1].X}, ${trail[1].Y} ${trail[1].X}, ${trail[1].Y} ${point.X}, ${point.Y}`

      self.setState({
        X: point.X,
        Y: point.Y,
        path: M + C + S,
        gX1: x1,
        gY1: y1,
        gX2: x2,
        gY2: y2,
      })
    }

    this.lastX = -10; this.lastY = -10; //刚开启的之后光点位于屏幕外，起到隐藏作用
    let animate = () => {
		if (!this.loaded) {
			return;
		}
		// if (!self.state.show) {
		// 	requestAnimationFrame(animate);
		// 	return;
		// }


      let boardSize = self.boardSize;
      let visible = this.state.visible;

      //通过回调处理
      let result = self.props.onLaserBoardAnimate && self.props.onLaserBoardAnimate(self, { mouse, boardSize, moved, visible });
      if (result) {
        self.setVisible(result.visible);
        draw(result.points);
      }
      else {
        // 无回调的默认行为
        self.setVisible(true);
        draw(mouse);
      }
      moved = false;

      requestAnimationFrame(animate);
    }

	this.loaded = true;
    animate();
  }
  setVisible = (v) => {
    if (this.state.visible !== v) {
      this.setState({
        visible: v,
      });
    }
  }

  // 注：这里的show & hide只决定了激光笔是否以dom的形式去绘制，不影响鼠标位置的获取
  show = () => {
    this.setState({
      show: true,
    });
  }

  hide = () => {
    this.setState({
      show: false,
    });
  }

  isShow = () => {
    return this.state.show;
  }

  unload() {
    document.removeEventListener('mousemove', this.handleMouseMove);
	  window.removeEventListener('resize', this.resize);
	  this.loaded = false;
  }
  componentWillUnmount() {
    this.unload();
  }
  resize = () => {
    let boardDom = findDOMNode(this.board);
    if (boardDom) {
      this.boardSize = {
        W: boardDom.offsetWidth,
        H: boardDom.offsetHeight,
      }
    }
  }
  render() {
    let showCursor = this.props.liveDelegate && this.props.liveDelegate.isAudience || false;

    const containerStyles = {};
    if (showCursor) containerStyles.cursor = 'inherit';
    if (!this.state.show) containerStyles.display = 'none';

    const pointerClass = 'pointer2 ' + styles.pointer2;
    return <div className={'pointingjs ' + styles.pointingjs} ref={e => { this.board = e }} style={containerStyles}>
      {
        <div
          className={pointerClass}
          style={{
            left: this.state.X - 17 + 'px',
            top: this.state.Y - 17 + 'px',
            opacity: this.state.visible ? 1 : 0
          }}></div>
      }
          {/* <svg className={styles.laser_svg} xmlns="http://www.w3.org/2000/svg"
            style={{ opacity: this.state.visible ? 1 : 0 }}
          >
                <defs>
                    <filter id="glow">
                        <feGaussianBlur className={styles.blur} result="coloredBlur" stdDeviation="4"/>
                        <feMerge>
                            <feMergeNode in="coloredBlur"></feMergeNode>
                            <feMergeNode in="coloredBlur"></feMergeNode>
                            <feMergeNode in="coloredBlur"></feMergeNode>
                            <feMergeNode in="SourceGraphic"></feMergeNode>
                        </feMerge>
                    </filter>
                    <linearGradient id="linear" x1={this.state.gX1} y1={this.state.gY1} x2={this.state.gX2} y2={this.state.gY2}>
                        <stop offset="0" stopColor="red" stopOpacity="0" />
                        <stop offset="1" stopColor="red" />
                    </linearGradient>
                </defs>
                <ellipse  cx={this.state.X} cy={this.state.Y} rx="8" ry="8" style={{'stroke': 'none', 'fill': '#F00'}} />
                <path className={styles.trail} stroke="url(#linear)"  fill="transparent" d={this.state.path} result="coloredBlur" />
          </svg> */}
          {/* <div style={{ position: 'fixed', bottom: '0px', width: '100%', height: 'auto', color: 'white', overflowWrap: 'break-word' }}>
            {JSON.stringify(this.props)}
          </div> */}
        </div>;
    }
}
LaserBoard.propTypes = {
  liveDelegate: PropTypes.any,
  scale: PropTypes.number
};
export default LaserBoard;
